@if (!data.images.length) {
    <div class="flex justify-center gap-3">
        <app-no-data-to-display
            [displayedMessage]="'unableToDisplayPicture'"
            [iconSize]="'5x'"
            [information]="'noDataFound'" />
    </div>
} @else {
    <div class="flex justify-between">
        <span class="font-normal text-2xl p-5">
            {{ data.title }}
        </span>

        <fa-icon
            class="cursor-pointer text-custom-dark-grey font-medium"
            size="2xl"
            [icon]="['fas', 'close']"
            [mat-dialog-close]="true" />
    </div>
    <div class="flex pt-2">
        <div class="w-full">
            @if (data.images.length > 1) {
                <div class="flex flex-col ml-4">
                    <app-images-carousel [images]="data.images" />
                </div>
            } @else {
                <img
                    alt="Result photo"
                    class="max-h-[80vh] w-full object-contain"
                    [src]="data.images[0]" />
            }
        </div>
    </div>
}
